<template lang="html">
  <div style="min-height: 100%">
    <!-- 产康 -->
    <recoveryComponent v-if="isRebuilding"></recoveryComponent>
    <!-- 公共的 -->
    <commonComponent v-else-if="product && product.spuId"></commonComponent>
    <empty v-else v-show="!firstFetch" text="没有找到该商品"></empty>
  </div>
</template>

<script>
import empty from '@/components/common/empty'
import commonComponent from './common'
import recoveryComponent from './recovery'
import Cookie from 'js-cookie'
import { mapState } from 'vuex'
import isIOS from '@/plugins/isIOS'
import ShareComponent from './shareComponent'
import { getLocation } from '@/plugins/location'

export default {
  data() {
    return {
      targetTime: 0,
      timeOffset: 0,
      spuId: 0,
      skuId: 0,
      ruleId: '',
      groupId: '',
      isInvited: 0,
      isIOS: true,
      businessId: '', //商家id
      commentDistance: 0,
      //introduceDistance: 720,  //设置默认值
      scrollIndex: 0,
      firstFetch: true,
      citycode: ''
    }
  },
  watch: {
    viewName(val, oldVal) {
      if (val !== oldVal && this.$store.state.needArrow) {
        this.$store.commit('setArrowState', false)
      }
    }
  },
  async created() {
    this.$$title('拼团详情')
    // 获取商品详情的内容

    try {
      await this.fetchGroupDetail()
      this.firstFetch = false
      this.businessId = this.getRealBusinessId()
      this.isIOS = isIOS
      this.getOtherServices()
      this.getComments()
      window.kwapp.allowRefreshOrShare(false, false)
    } catch (e) {
      if (window.kwapp && window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.allowRefreshOrShare(false, false)
        })
      }
      this.$$error(e, this)
    }

    this.$$loading(false)
  },
  destroyed() {},
  components: {
    commonComponent,
    recoveryComponent,
    empty,
    ShareComponent
  },
  computed: {
    // judgeIponex() {

    //     return isIOS && window.screen.height >= 812
    // },
    ...mapState([
      'product',
      'isCzjSpu',
      'groupInfo',
      'otherGroupsList',
      'viewName',
      'comments',
      'commentCount'
    ]),
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId &&
        parseInt(+this.product.level4CategoryId / 100) === 101121
      )
    }
  },
  methods: {
    async fetchGroupDetail() {
      const vueQuery = this.$route.query || {}
      this.spuId = this.$route.params.spuId || ''
      this.skuId = vueQuery.skuId || ''
      this.ruleId = vueQuery.ruleId || ''
      this.groupId = vueQuery.groupId || ''
      this.isInvited = vueQuery.isInvited * 1
      const query = this.$$queryString.stringify({
        spuId: this.spuId,
        skuId: this.skuId || '',
        ruleType: 4,
        ruleId: this.ruleId || '',
        uid: this.$$cookie('uid') || '',
        skey: this.$$cookie('uid') || '',
        appSource: this.$$getDevice()
      })
      await this.$store.dispatch('getProductDetail', query)
      // 如果没有groupDetail这个字段，跳正常商详
      if (Object.keys(this.groupInfo).length < 1) {
        location.replace(`/v/product/${this.spuId}?refresh=no`)
      }
      await this.$store.dispatch('getMainConfig')
      this.track()
      // eslint-disable-next-line no-useless-escape
      this.targetTime = new Date(
        this.groupInfo.endTime.replace(/\-/g, '/')
      ).getTime()
      this.timeOffset = this.groupInfo.serviceTime - Date.now()
      if (!this.groupInfo.serviceTime) {
        this.timeOffset = 0
      }
    },
    getOtherServices() {
      //获取本店其他服务
      this.$store.dispatch('getOtherServices', {
        spuId: this.spuId,
        businessId: this.businessId,
        cityId: this.citycode
      })
    },
    getCityCode() {
      const city = (this.$$cookie('city_service') || '').split('_')[0]
      if (city) {
        this.citycode = city
      } else {
        this.citycode = this.$$cookie('citycode') || '320100' //默认南京
      }
    },
    track() {
      if (this.product) {
        if (this.$$isHZWApp()) {
          this.$$newTrackView(this.getTrackParams(this.citycode))
        } else {
          getLocation()
            .then(({ citycode }) => {
              this.$$newTrackView(this.getTrackParams(citycode))
            })
            .catch(e => {
              this.$$newTrackView(this.getTrackParams(this.citycode))
            })
        }
      }
    },
    getTrackParams(citycode) {
      return {
        bizType: '127',
        pageLevelId: '121013031',
        pageParam: {
          citycode,
          spuid: this.product && this.product.spuId,
          categoryid: this.product && this.product.level4CategoryId
        }
      }
    },
    getRealBusinessId() {
      const { businessId, cmmdtyUseBusiness = [] } = this.product
      cmmdtyUseBusiness.forEach(element => {
        if (businessId === element.businessId) {
          return businessId
        }
      })
      if (cmmdtyUseBusiness.length > 0) return cmmdtyUseBusiness[0].businessId
    },
    getComments() {
      // 获取评价数据
      if (this.isCzjSpu) {
        this.getCZJComments()
      } else {
        this.getYuerComments()
      }
    },
    getYuerComments() {
      // 获取评价数据
      this.$store.dispatch('getComments', {
        page: 1,
        size: 2,
        spuId: this.spuId
      })
    },
    getCZJComments() {
      // 获取商品评价数据
      this.$store.dispatch('getCZJCommentList', {
        page: 1,
        size: 2,
        objectId: this.spuId,
        type: 4,
        uid: this.$$cookie('uid'),
        skey: this.$$cookie('skey')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

header {
  overflow: hidden;
  width: 100%;
  position: fixed;
  z-index: 100;
  left: 0;
  height: rem(88px);
  background: #fff;

  .tabbar {
    display: flex;
    height: rem(88px);
    padding-top: rem(24px);
    justify-content: center;
    @include border(bottom);

    .tabbar-item {
      color: #333;
      display: flex;
      flex-direction: column;
      font-size: rem(28px);

      .line {
        width: 100%;
        margin-top: rem(12px);
        height: rem(4px);
        background: #ff397e;
      }
    }

    .active {
      box-sizing: content-box;
      color: #ff397e;
      font-weight: bold;
      font-size: rem(28px);
    }

    li:nth-child(2) {
      margin: 0 rem(120px);
    }
  }
}

.group-content {
  padding-top: rem(88px);
  padding-bottom: rem(120px);
}

.group-detail {
  width: rem(750px);
  height: rem(250px);
  background: url('../../assets/images/bg_group_buy@3x.png') 0 0 no-repeat;
  background-size: contain;
  overflow: hidden;
  z-index: 99;

  .info-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: rem(40px) rem(20px) 0 rem(30px);
    color: #fff;

    .price {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .cur-price {
        font-size: rem(28px);
        margin-right: rem(4px);
        display: flex;
        align-items: flex-end;

        .cur-price-group {
          font-size: rem(48px);
          line-height: rem(44px);
          margin-right: rem(12px);
          margin-left: rem(4px);
        }
        .group-scale {
          padding: 0 rem(9px);
          font-family: PingFangSC-Regular;
          font-size: rem(20px);
          color: #ff397e;
          line-height: rem(28px);
          height: rem(28px);
          background: #ffffff;
          border-radius: rem(14px);
          align-self: center;
        }
      }

      .other-message {
        .pre-price {
          margin-top: rem(8px);
          font-size: rem(22px);
          line-height: rem(30px);
        }
      }
    }

    .count-down {
      display: flex;
      flex-direction: column;

      .end {
        font-size: rem(24px);
        line-height: rem(33px);
        margin-bottom: rem(6px);
        align-self: flex-end;
      }

      .countDown-content {
        font-size: rem(24px);
        color: #fff;
        display: flex;
        align-items: center;
      }
    }
  }
}

.group-info {
  margin: rem(-100px) rem(20px) rem(10px);

  .group-desc {
    background: #fff;
    padding: rem(30px) rem(10px) 0 rem(10px);
    font-size: rem(26px);
    color: #666666;
    border-radius: rem(8px);
    margin-bottom: rem(20px);

    .group-name {
      padding: 0 rem(20px);
      font-size: rem(36px);
      color: #121212;
      line-height: rem(40px);
      font-weight: bold;
      margin-bottom: rem(16px);
    }

    .service-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 0 rem(20px);
      line-height: rem(32px);
      margin-bottom: rem(10px);

      .company {
        margin-top: rem(16px);
        color: #999;
        overflow: hidden;
        display: flex;
        align-items: center;

        .shop-icon {
          display: inline-block;
          margin-right: rem(10px);
          width: rem(24px);
          height: rem(24px);
          box-sizing: border-box;
          background: url('//cmspic-10004025.image.myqcloud.com/086d4a90-225b-11ea-a5e7-dbd8a7023663_size_36x36')
            no-repeat center center;
          background-size: contain;
          flex-shrink: 0;
        }
      }
    }
  }

  .group-rule {
    width: rem(710px);
    height: rem(270px);
    background: url('//cmspic-10004025.image.myqcloud.com/9d1be160-b9b5-11e9-adc2-aff705ec5700_size_1065x405')
      0 0 no-repeat;
    background-size: contain;
    margin-bottom: rem(20px);
  }
}

.serve-detail {
  margin: 0 rem(-20px) 0;
}

.confirm-buttons {
  width: rem(750px);
  padding-top: rem(10px);
  padding-bottom: rem(10px);
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  z-index: 100;

  button {
    width: rem(340px);
    height: rem(80px);
    font-size: rem(32px);
    text-align: center;
    color: #fff;
    background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    border-radius: rem(40px);

    &.direct-reservation {
      border: 1px solid #ff6ea2;
      color: #ff397e;
      background: #fff;
    }

    &.invalid {
      background: #bbb;
    }
  }
}

.confirm-buttons.adapt-iponeX {
  padding-bottom: rem(50px);
}
</style>
